import React, {Component} from 'react';
import '../css/FlexHeader.css';
import {connect} from 'react-redux';
import {withRouter, Link} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {COLORS} from '../constants';
import Button from './Button';
import NavDrawer from './NavDrawer';
import Logo from './Logo';
import {getLang} from '../selectors';
import {updateLang} from '../actions';
import {FlexHeader as fhs} from '../strings';
import MediaQuery from 'react-responsive';

class Header extends Component {

  static HEIGHT = '100px';

  state = {
    navDrawerOpen: false,
  }

  handleScrollToContactForm = (event) => {
    event.preventDefault();

    const element = document.getElementById('HomePage-contactFormContainer');
    if (element) {
      const end = element.offsetTop;
      window.scroll({
        top: end - 40,
        behavior: 'smooth',
      })
    }
  }

  handleChangeLang = () => {
    const {lang, updateLang} = this.props;
    let nextLang;
    if (lang === 'en') {
      nextLang = 'es';
    }
    else if (lang === 'es') {
      nextLang = 'en'
    }

    return updateLang({lang: nextLang});
  }

  handleOpenNavDrawer = () => {
    this.setState({navDrawerOpen: true});
  }

  handleCloseNavDrawer = () => {
    this.setState({navDrawerOpen: false});
  }

  renderLarge() {
    const {lang} = this.props;

    let formattedLang;

    if (lang === 'en') {
      formattedLang = 'Español';
    }
    else if (lang === 'es') {
      formattedLang = 'English';
    }

    return(
      <div style={s.container}>

        <div style={s.item1}>
          <Logo />
        </div>

        <div style={s.item3}>
          
        </div>

        <div style={s.item4}>
          <NavLink
            label={fhs.programs[lang]}
            link="/programs"
          />

          <NavLink
            label={fhs.contact[lang]}
            link="/contact"
          />
        </div>

        <div style={s.item5}>
          <Button
            label={formattedLang}
            color="orange"
            onClick={this.handleChangeLang}
          />
        </div>

        {/*<div style={s.item6}>
          <div 
            style={s.lang}
            className="hover-pointer"
            onClick={this.handleChangeLang}
          >
            {formattedLang}
          </div>
        </div>*/}
      </div>
    )
  }

  renderSmall() {

    const {lang} = this.props;

    let formattedLang;

    if (lang === 'en') {
      formattedLang = 'ES';
    }
    else if (lang === 'es') {
      formattedLang = 'EN';
    }

    const s = {
      container: {
        position: 'fixed',
        top: '0px',
        left: '0px',
        width: '100%',
        height: Header.HEIGHT,
        backgroundColor: COLORS.black,
        zIndex: '10',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridColumnGap: '10px',
      },
      col1: {
        gridColumn: '1/2',
        alignSelf: 'center',
      },
      col2: {
        gridColumn: '2/3',
        alignSelf: 'center',
        justifySelf: 'end',
        display: 'flex',
        alignItems: 'center',
      },
      iconContainer: {
        color: COLORS.white,
      },
      icon: {

      },
      langContainer: {
        color: COLORS.orange,
        fontWeight: 'bold',
        marginRight: '30px',
        fontSize: '80%',
        //backgroundColor: COLORS.gray100,
      },
    }

    return(
      <div>
        <div style={s.container}>

          <div style={s.col1}>
            <Logo showText={true} />
          </div>

          <div style={s.col2}>
            <button 
              className='lang-container'
              onClick={this.handleChangeLang}
            >
              {formattedLang}
            </button>
            <button className='icon-container' onClick={this.handleOpenNavDrawer}>
              <FontAwesomeIcon
                icon="bars"
                className="menu-icon"
              />
            </button>
          </div>

          
        </div>
        <NavDrawer
          open={this.state.navDrawerOpen}
          onClose={this.handleCloseNavDrawer}
        />
      </div>
    )
  }

  render() {
    return (
      <div className='flex-header'>
        <MediaQuery maxWidth={799}>
          {this.renderSmall()}
        </MediaQuery>

        <MediaQuery minWidth={800}>
          {this.renderLarge()}
        </MediaQuery>
      </div>
    )
  }

}


const s = {
  container: {
    position: 'fixed',
    top: '0px',
    left: '0px',
    width: '100%',
    height: Header.HEIGHT,
    backgroundColor: COLORS.black,
    zIndex: '10',
    display: 'grid',
    //gridTemplateColumns: '40px farleft 50x midleft auto center 50px midright 40px right',
    gridTemplateColumns: '1fr 1fr 1.5fr 2fr 1fr',
    gridTemplateRows: '25% 50% 25%',
    gridColumnGap: '10px',
  },
  item1: {
    // gridColumnStart: '1',
    // gridColumnEnd: '2',
    gridColumn: '1 / 2',
    gridRow: '2/3',
    // gridRowStart: '1',
    // gridRowEnd: '3',
    //placeSelf: 'center',
    alignSelf: 'center',
  },
  item2: {
    gridColumnStart: '2',
    gridColumnEnd: '3',
    gridRow: '2/3',
  },
  item3: {
    gridColumnStart: '3',
    gridColumnEnd: '4',
    gridRow: '2/3',
  },
  item4: {
    gridColumnStart: '4',
    gridColumnEnd: '5',
    placeSelf: 'center',
    gridRow: '2/3',
    display: 'flex',
  },
  item5: {
    gridColumnStart: '5',
    gridColumnEnd: '6',
    gridRow: '2/3',
    marginRight: '20px',
    display: 'flex',
    justifySelf: 'flex-end',
  },
  item6: {
    gridColumn: '5/6',
    gridRow: '3/4',
    placeSelf: 'center',
    marginRight: '10px',
  },
  lang: {
    fontSize: '70%',
    fontWeight: 'bold',
    userSelect: 'none',
  },  
}

const NavLink = (props) => {
  const {label, link} = props;

  const s = {
    container: {
      margin: '0px 20px',
    },
    label: {
      fontWeight: 'bold',
      color: COLORS.white,
    },
  }

  return (
    <Link to={link} style={s.container}>
      <div style={s.label}>
        {label}
      </div>
    </Link>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    lang: getLang(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateLang: (params) => dispatch(updateLang(params)),
  }
}


const Connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(Header)

export default withRouter(Connected);



// WEBPACK FOOTER //
// ./src/main/FlexHeader.js